
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachDashboardRootNotificationsFormRemove} from "@/models/app/coach/dashboard/root/notifications/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "notification",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachDashboardRootNotificationsFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  notification: AppCoachDashboardRootNotificationsFormRemove = new AppCoachDashboardRootNotificationsFormRemove();

  formData: AppCoachDashboardRootNotificationsFormRemove = new AppCoachDashboardRootNotificationsFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/notification/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getNotifications');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.notification;
  }

  resetFormData(): void {
    this.formData = new AppCoachDashboardRootNotificationsFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
